import React, { useContext, useCallback, useMemo } from 'react';
import FilterViewList from '.';
import FulfillmentsDefaultFilterViewContainer from './filterview/fulfillments/default-filterview-container';
import FulfillmentsSavedFilterViewContainer from './filterview/fulfillments/saved-filterview-container';
import FulfillmentsCustomFilterViewContainer from './filterview/fulfillments/custom-filterview-container';
import { FulfillmentContext } from '../../shipping/fulfillments/context';
import { useModal } from '../../hooks/use-modal';
import { EditFulfillmentsFilterViewModalContainer } from '../../containers/external-fulfillments-filterview-modal-containers/edit-fulfillments-filterview-modal-container';
import { DeleteFulfillmentsFilterViewModalContainer } from '../../containers/external-fulfillments-filterview-modal-containers/delete-fulfillments-filterview-modal-container';
import { SaveFulfillmentsFilterViewModalContainer } from '../../containers/external-fulfillments-filterview-modal-containers/save-fulfillments-filterview-modal-container';
import { useSelectedShippingViewId } from '../../pages/shipping-page/shipping-left-nav/shipping-left-nav-context';

const FulfillmentsFilterViewList = () => {
  const currentGridViewId = useSelectedShippingViewId();
  const { isOpen: isDeleteViewModalOpen, close: closeDeleteViewModal, open: openDeleteViewModal } = useModal();
  const { isOpen: isEditViewModalOpen, close: closeEditViewModal, open: openEditViewModal } = useModal();
  const { isOpen: isSaveViewModalOpen, close: closeSaveViewModal, open: openSaveViewModal } = useModal();
  const { activeFilterViewId, savedFilterViews, defaultFilterView, customFilterView, switchActiveFilterView } =
    useContext(FulfillmentContext);

  const viewsToRender = useMemo(() => {
    const viewsForCurrentGrid = savedFilterViews.filter((view) => view.gridViewId === currentGridViewId);
    const views = [defaultFilterView, ...viewsForCurrentGrid];
    if (customFilterView) {
      views.push(customFilterView);
    }
    return views;
  }, [defaultFilterView, customFilterView, currentGridViewId, savedFilterViews]);

  const switchFilterView = useCallback(
    (newFilterViewId) => {
      switchActiveFilterView(newFilterViewId);
    },
    [switchActiveFilterView],
  );

  return (
    <>
      <FilterViewList
        activeFilterViewId={activeFilterViewId}
        CustomFilterViewContainer={FulfillmentsCustomFilterViewContainer}
        DefaultFilterViewContainer={FulfillmentsDefaultFilterViewContainer}
        FilterViewContainer={FulfillmentsSavedFilterViewContainer}
        filterViews={viewsToRender}
        openEditViewModal={openEditViewModal}
        openSaveViewModal={openSaveViewModal}
        switchActiveFilterView={switchFilterView}
      />
      {isEditViewModalOpen && (
        <EditFulfillmentsFilterViewModalContainer onClose={closeEditViewModal} openDeleteViewModal={openDeleteViewModal} />
      )}
      {isDeleteViewModalOpen && <DeleteFulfillmentsFilterViewModalContainer onClose={closeDeleteViewModal} />}
      {isSaveViewModalOpen && <SaveFulfillmentsFilterViewModalContainer onClose={closeSaveViewModal} />}
    </>
  );
};

export default FulfillmentsFilterViewList;
